import React from 'react'
import machine from '../img/machine.jpg'
import pcb from '../img/pcb.jpg'
import iot from '../img/iot.jpg'

import { useNavigate } from 'react-router-dom';

const HomeWorkshops = () => {
        
    const history=useNavigate();
   const openExplore=(page)=>{
     history(page);
   }
    return (
        <> <h2>Workshops</h2>
          <div className="home__events__content">
              <div className="event1">
                  <div className="img-container">

                  <img src={iot} alt="photo" onClick={()=>openExplore('explore1')}/>
                  </div>
                  <h3>IOT</h3>
              </div>
              <div className="event1">
                  <div className="img-container">
                    <img src={machine} alt="photo" onClick={()=>openExplore('explore2')}/>
                  </div>
                  <h3>Machine Learning</h3>
              </div>
              <div className="event1">
                  <div className="img-container">

                  <img src={pcb} alt="photo" onClick={()=>openExplore('explore3')}/>
                  </div>
                  <h3>PCB Design</h3>
              </div>
              </div>  
        </>
    )
}

export default HomeWorkshops
